
import { clearTimeout } from 'timers';
<template>
    <div class="content_main self" v-loading.fullscreen.lock="loading">
      <el-form ref="form" :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="姓氏">
        <el-input class="max_input" v-model="formLabelAlign.FirstName" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="名字">
        <el-input class="max_input" v-model="formLabelAlign.LastName" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span='12'>
            <el-form-item label="我是">
              <el-select v-model="formLabelAlign.Sex" placeholder="请选择">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="0"></el-option>
              </el-select>
            </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label="类型">
            <el-select v-model="formLabelAlign.NegType" placeholder="请选择">
              <el-option
                v-for="item in negTypeoptions"
                :key="item.KeyValue"
                :label="item.KeyName"
                :value="item.KeyValue">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="出生日期">
         <el-date-picker
          v-model="formLabelAlign.Birth"
          type="date"
          class="width_100"
          value-format='yyyy-MM-dd'
          placeholder="选择日期">
        </el-date-picker>

          <!-- <el-input class="max_input" v-model="formLabelAlign.Birth" placeholder="请输入内容"></el-input> -->
        </el-form-item>
      <el-form-item label="电子邮件">
          <el-input class="max_input" @input='changeEmail()' v-model="formLabelAlign.NegEmail" placeholder="请输入内容"></el-input>
		  <div class="self_email_getBtn" v-if='formLabelAlign.EmailValidate == 0' @click="getEmailCode(formLabelAlign.NegEmail)">
			  <label v-if='emailTime == 59'>获取验证码</label>
			  <label v-if='emailTime != 59'>{{emailTime}}s</label>
		  </div>
          <div class="self_email_confirm">
            <label v-if="formLabelAlign.EmailValidate == 1">已确认</label>
			<el-input v-model='emailCode' v-if="formLabelAlign.EmailValidate == 0" @blur="emailBlur" class="self_email_confirm_input" placeholder="验证码"></el-input>
          </div>
      </el-form-item>
      <el-form-item label="手机号码">
          <el-input class="max_input" @input='changePhone()' v-model="formLabelAlign.NegPhone1" placeholder="请输入内容"></el-input>
		  <div class="self_email_getBtn" v-if='formLabelAlign.PhoneValidate == 0' @click="getPhoneCode(formLabelAlign.NegPhone1)">
			  <label v-if='phoneTime == 59'>获取验证码</label>
			  <label v-if='phoneTime != 59'>{{phoneTime}}s</label>
		  </div>
		  <div class="self_email_confirm">
            <label v-if="formLabelAlign.PhoneValidate == 1">已确认</label>
			<el-input v-model='phoneCode' v-if="formLabelAlign.PhoneValidate == 0" @blur="phoneBlur" class="self_email_confirm_input" placeholder="验证码"></el-input>
          </div>
      </el-form-item>
      <el-form-item label="自我介绍">
          <el-input class="self_textarea" type="textarea" v-model="formLabelAlign.Note"></el-input>
      </el-form-item>
      <el-form-item class="preserveBtn">
          <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
    </div>
</template>

<script>
export default {
  data(){
    return {
      personal: {},
      labelPosition: 'right',
      formLabelAlign: {
        NickName: '',
        FirstName: '',
        LastName: '',
        NegEmail: '',
        NegPhone1: '',
        Sex: 1,
        NegType: '',
        Note: '',
        Birth: ''
	  },   
		emailCode:'',
		phoneCode:'',
    negTypeoptions: [],
	  loading: true,
	  oldEmail:'',
	  oldPhone:'',
	  emailTime:59,
	  phoneTime:59
    }
  },
  methods:{
    getPropertyType(){
      this.$get('/Handler/FYGL.ashx',{Action:'GetNegType'},(data)=>{
        data.forEach(function(el){
          el.KeyValue = String(el.KeyValue);
        });
        this.negTypeoptions = data;
      },(err)=>{
		  this.$message.error(err);
      });
	},
	getEmailCode(value){
		this.$get('/Handler/Login.ashx',{Action:'SendVerificationCode',UserName:value},data => {
			let timer = setInterval(() => {
				this.emailTime -= 1;
				if(this.emailTime == 0){
					clearInterval(timer);
					this.emailTime = 59;
				}
			},1000);
			this.$message('验证码发送成功!');
		},error => {
			this.$message.error(error);
		});
	},
	getPhoneCode(value){
		this.$get('/Handler/Login.ashx',{Action:'SendMobileCode',UserName:value},data => {
			let timer = setInterval(() => {
				this.phoneTime -= 1;
				if(this.phoneTime == 0){
					clearInterval(timer);
					this.phoneTime = 59;
				}
			},1000);
			this.$message('验证码发送成功!');
		},error => {
			this.$message.error(error);
		});
	},
	phoneBlur(){
		let params = {
			Action:'CompareMobileCode',
			VerifyCode:this.phoneCode,
			Phone:this.formLabelAlign.NegPhone1
		}
		this.$get('/Handler/FYGL.ashx',params,data => {
			this.formLabelAlign.PhoneValidate = 1;
		},error => {
      this.$message.error(error);
      this.phoneCode = '';
		});
	},
	emailBlur(){
		let params = {
			Action:'CompareMobileCode',
			VerifyCode:this.emailCode,
			Phone:this.formLabelAlign.NegEmail
		}
		this.$get('/Handler/FYGL.ashx',params,data => {
			this.formLabelAlign.EmailValidate = 1;
		},error => {
      this.$message.error(error);
      this.emailCode = '';
		});
	},
    getOwner(){
        this.$get('/Handler/FYGL.ashx',{Action:'GetNegotiator',Owner_ID:'B5ADC8A100332EB76EC44F6FF445CEFD'},(data)=>{
          this.loading = false;
            this.formLabelAlign = data[0];
            this.formLabelAlign.Sex = String(data[0].Sex);
			this.formLabelAlign.NegType = String(data[0].NegType);
			this.oldEmail = _.cloneDeep(data[0].NegEmail);
			this.oldPhone = _.cloneDeep(data[0].NegPhone1);
        },(err)=>{
			this.$message.error(err);
        });
    },
	changeEmail(){
		if(this.oldEmail == this.formLabelAlign.NegEmail){
		this.formLabelAlign.EmailValidate = 1;
			return
		}
		this.formLabelAlign.EmailValidate = 0;
	},
	changePhone(){
		if(this.oldPhone == this.formLabelAlign.NegPhone1){
			this.formLabelAlign.PhoneValidate = 1;
			return
		}
		this.formLabelAlign.PhoneValidate = 0;
	},
    onSubmit() {
		if(this.formLabelAlign.PhoneValidate == 0){
			this.$message.error('请先校验手机号');
			return
		}
		if(this.formLabelAlign.EmailValidate == 0){
			this.$message.error('请先校验邮箱');
			return
		}
		this.formLabelAlign.isWSXX = 1;
      var params = {
        JsonData: JSON.stringify(this.formLabelAlign)
      }
      this.$post('/Handler/FYGL.ashx',params,{Action: 'UpdateNegotiator'},data => {
          this.$alert('信息修改成功！', '操作提示',{
            confirmButtonText: '确定'
          });
      },err => {
        this.$message.error(err);
      })
    }
  },
  created(){
    this.getOwner()
    this.getPropertyType()
  }
}
</script>

<style scoped>
.self{
  width:520px;
  margin: 50px auto;
}
.self .preserveBtn{
  margin-left: 300px;
}
.self .self_textarea{
	resize:none;
}
.self .self_email_confirm{
	display: inline-block;
    position: absolute;
	width:100px;
    top: 0px;
    right: -104px;
    color: rgb(46, 204, 113);
}
.self_email_getBtn{
	display: inline;
    position: absolute;
    top: 0px;
    right: 8px;
	cursor: pointer;
	color:#7ab2fe;
}
.self .self_email_confirm_input{
	/* width:80px; */
}
</style>



// WEBPACK FOOTER //
// src/pages/controlPanel/components/self/self.vue